
import styled from 'styled-components'

import MEDIA from 'constants/media'
import FONTS from 'constants/fonts'


export const Wrap = styled.div`
  margin: 40px auto 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  max-width: 880px;
`

export const GroupItem = styled.div`
  margin: 20px;
  text-align: center;
`

export const LocationTitle = styled.h3`
  text-align: center;
  font-size: ${FONTS.FONTSECTIONTITLEMOBILE};
  margin: 0 0 5px;
  a:link,
  a:visited {
    color: #000;
  }
  span {
    display: block;
    font-size: ${FONTS.PARAGRAPH};
    margin: 5px 0;
  }
  ${MEDIA.medium`
    font-size: 30px;
  `}
`
